import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e01c0b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-4 flex flex-col gap-4 font-inter pb-20" }
const _hoisted_2 = { class: "flex items-center gap-4" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl font-bold" }, "Cardápio", -1))
const _hoisted_4 = { class: "flex-1" }
const _hoisted_5 = { class: "flex gap-2 overflow-x-auto pb-2 scrollbar-hide" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "flex justify-between items-center mt-2" }
const _hoisted_8 = { class: "text-lg font-semibold text-gray-700" }
const _hoisted_9 = { class: "text-sm text-gray-400" }
const _hoisted_10 = {
  key: 0,
  class: "grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "aspect-square relative overflow-hidden bg-gray-50" }
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  key: 1,
  class: "w-full h-full flex items-center justify-center text-gray-300"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "48",
  height: "48",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    width: "18",
    height: "18",
    x: "3",
    y: "3",
    rx: "2",
    ry: "2"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "9",
    cy: "9",
    r: "2"
  }),
  /*#__PURE__*/_createElementVNode("path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21" })
], -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "absolute bottom-2 right-2 bg-white/90 backdrop-blur px-2 py-1 rounded-lg text-xs font-bold text-gray-800" }
const _hoisted_18 = { class: "p-3" }
const _hoisted_19 = { class: "font-bold text-sm text-gray-800 line-clamp-2" }
const _hoisted_20 = { class: "text-xs text-gray-400 mt-1 line-clamp-2" }
const _hoisted_21 = {
  key: 1,
  class: "flex flex-col items-center justify-center py-20 text-gray-400"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "64",
  height: "64",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  class: "mb-4 opacity-20"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "11",
    cy: "11",
    r: "8"
  }),
  /*#__PURE__*/_createElementVNode("path", { d: "m21 21-4.3-4.3" })
], -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Nenhum produto encontrado", -1))
const _hoisted_24 = [
  _hoisted_22,
  _hoisted_23
]

import { onMounted, ref, computed, watch } from 'vue';
import { categories, products, selectedCommand, organizationSettings, apiBaseUrl } from '@/global/state/GlobalState';
import ProductModal from '@/components/modal/ProductModal.vue';
import axiosClient from '@/api/axios';
import router from '@/router';


export default /*#__PURE__*/_defineComponent({
  __name: 'PosView',
  props: {
    tab_id: {}
  },
  setup(__props: any) {

const props = __props

const selectedProduct = ref<any>(null)
const filteredProducts = ref<any[]>([])
const searchQuery = ref('')
const selectedCategoryId = ref<number | null>(null)
const isProductModalOpen = ref<boolean>(false)

const isSelectedTableOpen = computed(() => {
    return !!selectedCommand.value
})

onMounted(async () => {
    if(!isSelectedTableOpen.value && !props.tab_id){
        router.push({name:'tables'})
        return
    }

    if(props.tab_id && !selectedCommand.value){
        try {
            const res = await axiosClient.get(`/tabs/${props.tab_id}`)
            selectedCommand.value = res.data.data || res.data
        } catch (error) {
            router.push({name:'tables'})
            return
        }
    }

    filterProducts()
})

watch(() => products.value, () => {
    filterProducts()
}, {deep:true})

function filterProducts(){
    filteredProducts.value = products.value.filter((product: any) => {
        const matchesSearch = product.name.toLowerCase().includes(searchQuery.value.toLowerCase())
        const matchesCategory = selectedCategoryId.value ? product.categoryId === selectedCategoryId.value : true
        return matchesSearch && matchesCategory
    })
}

function selectCategory(categoryId: number | null){
    selectedCategoryId.value = categoryId
    filterProducts()
}

watch(searchQuery, () => {
    filterProducts()
})

const currentCategoryName = computed(() => {
    if(!selectedCategoryId.value) return 'Todos os produtos'
    return categories.value.find((c: any) => c.id === selectedCategoryId.value)?.name || ''
})

const setModalProduct = (product: any) => {
    selectedProduct.value = product
    isProductModalOpen.value = true
}

const toggleProductModal = (isOpen: boolean) => {
    isProductModalOpen.value = isOpen
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
          type: "text",
          placeholder: "Pesquisar produto...",
          class: "w-full p-3 bg-gray-100 rounded-xl focus:outline-none focus:ring-2 focus:ring-primary/20 transition"
        }, null, 512), [
          [_vModelText, searchQuery.value]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (selectCategory(null))),
        class: _normalizeClass([!selectedCategoryId.value ? 'bg-primary text-white' : 'bg-gray-100 text-gray-600', "px-4 py-2 rounded-full whitespace-nowrap font-medium transition duration-200"])
      }, " Todos ", 2),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(categories), (category) => {
        return (_openBlock(), _createElementBlock("button", {
          key: category.id,
          onClick: ($event: any) => (selectCategory(category.id)),
          class: _normalizeClass([selectedCategoryId.value === category.id ? 'bg-primary text-white' : 'bg-gray-100 text-gray-600', "px-4 py-2 rounded-full whitespace-nowrap font-medium transition duration-200"])
        }, _toDisplayString(category.name), 11, _hoisted_6))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("h2", _hoisted_8, _toDisplayString(currentCategoryName.value), 1),
      _createElementVNode("span", _hoisted_9, _toDisplayString(filteredProducts.value.length) + " produtos", 1)
    ]),
    (filteredProducts.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredProducts.value, (product) => {
            return (_openBlock(), _createElementBlock("div", {
              key: product.id,
              onClick: ($event: any) => (setModalProduct(product)),
              class: "bg-white rounded-2xl overflow-hidden box-shadow border hover:border-primary transition duration-300 cursor-pointer flex flex-col"
            }, [
              _createElementVNode("div", _hoisted_12, [
                (product.media?.length)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _unref(apiBaseUrl) + '/storage/' + product.media[0].path,
                      class: "w-full h-full object-cover transition duration-500 hover:scale-110"
                    }, null, 8, _hoisted_13))
                  : (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16)),
                _createElementVNode("div", _hoisted_17, _toDisplayString(product.price.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })), 1)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("h3", _hoisted_19, _toDisplayString(product.name), 1),
                _createElementVNode("p", _hoisted_20, _toDisplayString(product.description), 1)
              ])
            ], 8, _hoisted_11))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_24)),
    _createVNode(ProductModal, {
      isOpen: isProductModalOpen.value,
      toggleModal: toggleProductModal,
      product: selectedProduct.value
    }, null, 8, ["isOpen", "product"])
  ]))
}
}

})